import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

@inject("NavListStore")
@observer
class TopbarText extends Component {
  get navMetaData() {
    return (
      (this.props.NavListStore.navListData &&
        this.props.NavListStore.navListData.data &&
        this.props.NavListStore.navListData.data.metaData) ||
      {}
    );
  }

  render() {
    if (this.navMetaData.topBandMessage) {
      return (
        <div className="nw-topbartext">
          <a className="nw-topbartext-link" href={this.navMetaData.topBandUrl}>
            <i className="icomoon-star nw-topbartext-star nw-topbartext-starviolet" />
            <i className="icomoon-star nw-topbartext-star nw-topbartext-staryellow" />
            <i className="icomoon-star nw-topbartext-star nw-topbartext-starpink" />
            <div className="nw-topbartext-text">
              <span className="nw-topbartext-eachtext">
                {/* <span className="nwc-text-primary">
                </span> */}
              </span>
              <span className="nw-topbartext-eachtext">
                {this.navMetaData.topBandMessage}
              </span>
            </div>
            <i className="icomoon-star nw-topbartext-star nw-topbartext-starpink" />
            <i className="icomoon-star nw-topbartext-star nw-topbartext-staryellow" />
            <i className="icomoon-star nw-topbartext-star nw-topbartext-starviolet" />
          </a>
        </div>
      );
    }

    return null;
  }
}

TopbarText.wrappedComponent.propTypes = {
  NavListStore: PropTypes.shape({
    navListData: PropTypes.object,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("NavListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: TopbarText.wrappedComponent,
  component: TopbarText,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/TopbarText/index.js